/* eslint-disable no-restricted-globals */
import React,{ Component } from 'react';
// import { Link } from 'react-router-dom';
import { connect } from 'react-redux'; 
// import { LinkContainer } from 'react-router-bootstrap';
import { callGET, callDELETE } from '../../../Utils/ApiUtil';
import { getUserInfo } from '../../../Utils/UserFunctions';
// import Pagination from '../../../Components/Pagination';
// import Icons from '../../../Components/Icons/Icons';
import * as actions from '../../../store/actions';
import * as ShipConstants from '../../../Global/Constants';
import TableRecord from "../../../Components/UI/TableRecord";
import Wrp from "../../../hoc/Wrp/Wrp";

class UsersList extends Component {
  state ={
    is_system_user: false,
    tableRecords:{
      tableHead:[
        {
          name:"Action",
          type:"Actions",
          href:"",
          isShow:true,
          clickHandler:"",
          attributes:{
            style:{width: "75px"}
          }
        },
        {
          name:"Name",
          type:"NoHref",
          sortName:"last_name",
          clickHandler:"",
          isShow:true,
          attributes:{
          }
        },
        {
          name:"Username",
          type:"NoHref",
          sortName:"username",
          clickHandler:"",
          isShow:true,
          attributes:{
          }
        },
        {
          name:"Email",
          type:"NoHref",
          sortName:"email",
          clickHandler:"",
          isShow:true,
          attributes:{
          }
        },
        {
          name:"User Type",
          type:"NoHref",
          sortName:"is_external",
          clickHandler:"",
          isShow:true,
          attributes:{
          }
        },
        {
          name:"Role",
          type:"NoHref",
          clickHandler:"",
          isShow:true,
          attributes:{
          }
        },
        {
          name:"Profile",
          type:"NoHref",
          clickHandler:"",
          isShow:true,
          attributes:{
          }
        },
        {
          name:"Work Number",
          type:"HyperLink",
          sortName:"work_number",
          clickHandler:"",
          isShow:true,
          attributes:{
          }
        },
        {
          name:"Mobile Number",
          type:"HyperLink",
          sortName:"mobile_number",
          clickHandler:"",
          isShow:true,
          attributes:{
          }
        },
      ],
      tableData:[], 
      pagination:{
        page:0,
        orderBy:'email',
        perPage:10,
        direction:'ASC',
        totalRecords:0,
        search:''
      }
    }
  }

  componentWillMount = () => {
    const system_user = getUserInfo().data.system_user;
    this.setState({is_system_user: system_user});
  }

  componentDidMount() {
    this.usersList(this.state.tableRecords.pagination);
  }

  deleteUsers = (ide) => {
    // let isDelete = window.confirm("are you sure you want to In-Active this user?");
    // if(isDelete) {
      callDELETE("users/"+ide)
      .then(response => {
        const responseData = response.data;
        if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
          this.props.succMessage(responseData.message);
        }else {
          this.props.failMessage(responseData.message);
        }
        this.usersList(this.state.tableRecords.pagination);
      })
    // }
  }

  usersList = (pagination) => {
    this.props.Loader();
    const page = pagination.page; 
    const orderBy = pagination.orderBy; 
    const perPage = pagination.perPage; 
    const direction = pagination.direction; 
    const search = pagination.search;
    this.setState({
      tableRecords:{
        ...this.state.tableRecords,
        pagination:pagination
      }
    })
    let status = 'inactive';
    if(this.props.show==='users') {
      status = 'active';
    }
    callGET("users/fetch-users/"+status+"?query="+search+"&orderBy="+orderBy+"&direction="+direction+"&page="+page+"&size="+perPage)
        .then(res => {
          const response = res.data;
          this.props.Loader(false);
          if(response.code===200){
            let updateTableData = response.data.content.map((item,index)=>{
                return {
                  className:' ',
                  rowId:"",
                  data:{
                    actions:[
                      {
                        href:"/edit-user/"+item.id,
                        attributes:{
                          className:"p-1"
                        },
                        //iconClass:"fas fa-pencil-alt",
                        //iconType:"Edit",
                        svgIcon:"Edit",
                        name:""
                      },
                      {
                        attributes:{
                          className:"p-1"
                        },
                        //iconClass:"fas fa-trash-alt primary_color",
                        svgIcon:"Delete",
                        clickHandler:this.deleteUsers.bind(this,item.id),
                        content:'User will be In-Activated.',
                        name:"",
                        access_mode: ((this.state.is_system_user===true && item.is_system_user===false) || (item.is_organization_admin === false && this.state.is_system_user===false)) ?
                          (this.props.show==='users') ? true : false
                          : ''
                      }
                      
                  ],
                    name:{
                      value:item.last_name +" " + item.first_name
                    },
                    username:{
                      value:item.username
                    },
                    email:{
                      value:item.email
                    },
                    user_type:{
                      value:(item.is_external===true)?'External':'Internal'
                    },
                    role:{
                      value:item.role_name,
                    },
                    profile:{
                      value:item.profile_name
                    },
                    work_number:{
                      value:item.work_number,
                    },
                    mobile_number:{
                      value:item.mobile_number
                    },
                  }
                }
                  
            });
            const totalRecords = response.data.total_elements;
            console.log({status:200, tableRecords:{
              tableData:{data:updateTableData,status:200},
              tableHead:this.state.tableRecords.tableHead ,
              pagination:{...this.state.tableRecords.pagination,totalRecords:totalRecords}
            }});
            this.setState({status:200, tableRecords:{
              tableData:{data:updateTableData,status:200},
              tableHead:this.state.tableRecords.tableHead ,
              pagination:{...this.state.tableRecords.pagination,totalRecords:totalRecords}
            }});
          }else{
            const totalRecords = 0;//response.data.totalElements;
            this.setState({status:200, tableRecords:{
              tableData:[],
              tableHead:this.state.tableRecords.tableHead ,
              pagination:{...this.state.tableRecords.pagination,totalRecords:totalRecords}
            }});
          }
        })
        .catch(err => {
          this.props.Loader(false);
          console.log("errror============",err);
        });
  }

  render() {
  return (
      <Wrp>
       
      {/* <div className="view UserList">
        <div className="outerPort"> */}
          <TableRecord 
            tableRecords={this.state.tableRecords} 
            recordsChangeHandler={this.usersList}
          />
        {/* </div>
      </div> */}
    </Wrp> 
  ) }
}

const mapStateToProps = state => {
  return {
    authenticated: state
  };
}

const mapDispatchToProps = dispatch => {
  return {
    Loader : (bool) => dispatch(actions.loader(bool)),
    succMessage : (msg) => dispatch(actions.succMessage(msg)),
    failMessage : (msg) => dispatch(actions.failMessage(msg))    
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UsersList);